// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/cc55190c4b929e9f2abd.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"1e92dc8e86c5c39e899f","159":"3db72d9d252746c99912","160":"b287a6543e9cc1bc333b"}[chunkId] + ".chunk.js";
};